
export default class ReviewsIndicatorsController {

	constructor (
		stores,
		selectedStore,
		endDate,
		startDate,
		reviewsIndicators
	) {
		this.stores = stores;
		this.selectedStore = selectedStore;
		this.endDate = endDate;
		this.startDate = startDate;
		this.graphs = reviewsIndicators.graphs;
	}

}

ReviewsIndicatorsController.$inject = [
	'stores',
	'selectedStore',
	'endDate',
	'startDate',
	'reviewsIndicators'
];



// WEBPACK FOOTER //
// ./src/page/reviewsIndicators/reviewsIndicators.controller.js